import type { CSSProperties, HTMLAttributeReferrerPolicy, MouseEvent, ReactNode } from "react";

import { ButtonContent, getButtonClassName, type ButtonContentAlign } from "./buttonShared";

type ExternalButtonProps = {
    icon?: string;
    disabled?: boolean;
    children?: ReactNode;
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
    className?: string;
    contentAlign?: ButtonContentAlign;
    showArrow?: boolean;
    href: string;
    target?: string;
    rel?: string;
    referrerPolicy?: HTMLAttributeReferrerPolicy;
    style?: CSSProperties;
};

export default function ExternalButton({
    icon,
    disabled = false,
    children,
    onClick,
    className,
    contentAlign = "left",
    showArrow = true,
    href,
    target,
    rel,
    referrerPolicy,
    style,
}: ExternalButtonProps) {
    const buttonClassName = getButtonClassName({ disabled, className, contentAlign });

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        if (disabled) {
            event.preventDefault();
            return;
        }

        onClick?.(event);
    };

    return (
        <a
            aria-disabled={disabled}
            className={buttonClassName}
            href={href || "#"}
            onClick={handleClick}
            referrerPolicy={referrerPolicy}
            rel={rel}
            style={style}
            tabIndex={disabled ? -1 : undefined}
            target={target}
        >
            <ButtonContent icon={icon} showArrow={showArrow}>{children}</ButtonContent>
        </a>
    );
}
